import { useCallback, useEffect, useMemo } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useSchemeStatusMaster() {
  const {formatMessage} = useIntl();
  
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const schemesMasterData = getData(state, apiKeys.schemesListMaster, []);
  const schemesMasterStatus = getStatus(state, apiKeys.schemesListMaster, '');
  const schemesMasterErrMsg = getErrorMessage(state, apiKeys.schemesListMaster, '');
  const rejectedCustomersData = getData(state, apiKeys.schemeRejectedCustomersList, []);
  const rejectedCustomersStatus = getStatus(state, apiKeys.schemeRejectedCustomersList, '');
  const rejectedCustomersErrMsg = getErrorMessage(state, apiKeys.schemeRejectedCustomersList, '');
  const deleteSchemesMasterStatus = getStatus(state, apiKeys.deleteSchemesListMaster, '');
  const resubmitRejectedCustomerStatus = getStatus(state, apiKeys.resubmitRejectedCustomer, '');

   const getSchemesListMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.schemesListMaster,
      method: apiMethods.GET,
      key: apiKeys.schemesListMaster,
      failureMsg: formatMessage({id: "failed-to-get-schemes-list-master"}),
    }))
  }, [dispatch, formatMessage])

  const getRejectedCustomersList = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.schemeRejectedCustomersList,
      method: apiMethods.GET,
      key: apiKeys.schemeRejectedCustomersList,
      failureMsg: "Failed to get rejected customers list",
    }))
  }, [dispatch])

  useEffect(() => {
    getSchemesListMaster()
    getRejectedCustomersList()
  }, [dispatch, getSchemesListMaster, getRejectedCustomersList]);

  useEffect(() => {
    if(deleteSchemesMasterStatus === apiStatuses.succeeded || resubmitRejectedCustomerStatus === apiStatuses.succeeded){
      getSchemesListMaster();
      getRejectedCustomersList();
    }
  }, [deleteSchemesMasterStatus, resubmitRejectedCustomerStatus, getSchemesListMaster, getRejectedCustomersList])

  useEffect(() => ()=> {
    dispatch(clearData({key: apiKeys.schemesListMaster}));
    dispatch(clearData({key: apiKeys.schemeRejectedCustomersList}));
  }, [dispatch]);

    return useMemo(() => ({
      schemesMasterData,
      schemesMasterStatus,
      schemesMasterErrMsg,
      rejectedCustomersData,
      rejectedCustomersStatus,
      rejectedCustomersErrMsg
    }),[
      schemesMasterData,
      schemesMasterStatus,
      schemesMasterErrMsg,
      rejectedCustomersData,
      rejectedCustomersStatus,
      rejectedCustomersErrMsg
    ])
 
}
